import { DataSource, FormOption } from '@qfa/forms';
import { FilterOperator, useSignSelectionListLazyQuery } from '@kinetic-ui/data-layer';
import { getNodes } from 'kineticUtils/data';
import { useCallback } from 'react';

type UseSignDataSourceProps = { integrations?: string[] };
export const useSignDataSource = ({
  integrations = [],
}: UseSignDataSourceProps): DataSource<FormOption[]> => {
  const [getSigns] = useSignSelectionListLazyQuery();
  const load = useCallback(async () => {
    let variables: any = { limit: 10_000 };
    if (integrations.length) {
      variables = {
        limit: integrations.length,
        filters: [
          {
            operator: FilterOperator.In,
            value: integrations,
            field: 'id',
          },
        ],
      };
    }
    const { data } = await getSigns({ variables });
    return getNodes(data?.signs).map(({ name, id }) => ({
      label: name,
      value: id,
    })) as FormOption[];
  }, [getSigns, integrations]);
  return { load };
};
